import { createFileRoute, useParams } from "@tanstack/react-router";
export const Route = createFileRoute("/admin/_layout/expense/reports_/$id")({
  component: AdminExpenseReportDetail,
});

import { ExpenseReportDetailPage } from "@/components/expense/ExpenseReportDetailPage";

function AdminExpenseReportDetail() {
  const { id } = useParams({ from: "/admin/_layout/expense/reports_/$id" });
  return (
    <ExpenseReportDetailPage
      reportId={id}
      backUrl="/admin/expense/reports"
    />
  );
}
